﻿export class ParticipantDetails {
    sexID: number;
    territoryID: number;
    ageStructureID: number;
    sensitiveCategoryID: number;
    unemploymentPeriodID: number;
    surveyParticipantID: number;
}